let settings = [

    {
        path: '2 0 22 2 24 63 81 64 81 81 10 85 0 79',
        key: 'angle',
        density: .0001,
        img: 'angle',
    },

    {
        path: '22 0 42 4 49 26 113 31 114 46 92 53 90 111 67 115 60 93 3 92 0 75 20 70',
        key: 'brick',
        density: .1,
        img: 'brick',
    },

    {
        path: '0 11 9 0 55 41 56 114 59 129 34 132 3 93 8 31',
        key: 'cable',
        density: .0001,
        img: 'cable',
    },

    {
        path: '36 0 82 47 111 31 123 47 87 79 72 78 36 34 18 50 0 36',
        key: 'chevron',
        density: .0001,
        img: 'chevron',
    },

    {
        path: '21 0 53 2 55 22 96 25 94 50 75 55 76 94 44 100 42 80 1 77 0 49 10 47 22 45',
        key: 'peacock',
        density: .0001,
        img: 'peacock',
    },

    {
        path: '46 0 92 37 88 77 45 107 0 77 1 28',
        key: 'cube',
        density: .0001,
        img: 'cube',
    },

    {
        path: '33 1 65 0 98 39 69 77 35 80 0 38',
        key: 'diamond',
        density: .0001,
        img: 'diamond',
    },

    {
        path: '22 0 54 5 95 50 91 58 55 60 53 97 41 100 2 60 0 47',
        density: .0001,//     
        img: 'arrow',
    },

    {
        path: '0 6 18 0 110 5 118 15 107 22 9 21',
        density: .0001,//     
        img: 'line',
    },

    {
        path: '21 8 34 2 57 0 75 3 84 12 83 28 70 52 57 72 46 86 33 93 19 93 8 82 0 71 0 60 7 49 26 46 21 37 15 22',
        density: .0001,//     
        img: 'square',
    },

    {
        path: '46 0 68 33 76 60 64 73 40 72 13 67 0 56 5 43',
        density: .0001,//     
        img: 'triangle',
    },

    {
        path: '11 0 65 27 62 42 39 72 39 85 57 113 13 139 3 132 15 84 0 9',
        density: .0001,//     
        img: 'zigzag',
    },

    {
        path: '5 0 34 18 69 27 75 65 94 92 4 98 0 84',
        density: .0001,//     
        img: 'eye',
    },

]

export default settings




    





